module.exports = __webpack_public_path__ + "static/media/ing.7e624fcf.svg";